import { useCallback, useSyncExternalStore } from "react";
import { screens } from "./tokens";

export function useMediaQuery(size: "sm" | "md" | "lg") {
  const value = screens[size];
  const query = `only screen and (max-width : ${value})`;

  const subscribe = useCallback(
    (callback: () => void) => {
      if (typeof window === "undefined") {
        return () => null;
      }
      const matchMedia = window.matchMedia(query);
      matchMedia.addEventListener("change", callback);
      return () => matchMedia.removeEventListener("change", callback);
    },
    [query],
  );

  const getSnapshot = () =>
    typeof window === "undefined" ? null : window.matchMedia(query).matches;

  const getServerSnapshot = () => {
    return null;
  };

  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
